/* eslint-disable @typescript-eslint/no-explicit-any */
const itemDefault = {
  id: null,
  A_NOM_DE: null,
  HVPR_ALERTA_TEMPRANA: null,
  QUIEN_INFORMA: null,
  PERSONAS_EN_RIESGO: [],
  LUGAR_ALERTA: null,
  LUGAR_ALERTA_OTRO: null,
  DIRECCION_ALERTA: null,
  DESCRIPCION_ALERTA: null,
  ESTADO_ALERTA: null,
  NOMBRE_INFO_ALERTA: null,
  APELLIDO_INFO_ALERTA: null,
  TIPODOCU_INFO_ALERTA: null,
  NDOCU_INFO_ALERTA: null,
  GENERO_INFO_ALERTA: null,
  EDAD_INFO_ALERTA: null,
  COMUNA_ID: null,
  BARRIO_ID: null,
  COMUNA_NAME: null,
  BARRIO_NAME: null,
  EMAIL_INFORMA: null,
  EMAIL_INFORMA_V: null, // No se guarda en BD
  NCONTACTO_INFORMA: null,
  NCONTACTO_FIJO_INFORMA: null,
  V_SEERIESGOEVIOSEX: 0,
  V_SEERIESGOESCNNA: 0,
  V_CSRUUC: 0,
  V_PDEBETRABAJAR: 0,
  V_PMTIEMPOCALLE: 0,
  V_VIDAENCALLE: 0,
  V_TPCONVIPYFAMILIA: 0,
  V_TPVIOINTRAFAMILIA: 0,
  V_GOCE_SALUD: 0,
  V_GOCE_EDUACION: 0,
  V_GOCE_ALIMENTACION: 0,
  V_GOCE_SERVICIOS_PUBLICOS: 0,
  V_GOCE_VIVIENDA: 0,
  V_GOCE_RECREACION: 0,
  V_GOCE_TRABAJO: 0,
  V_GOCE_SEXUALES_REPRO: 0,
  V_GOCE_LIBRE_DES_PERSONAL: 0,
  V_GOCE_LIBERTAD: 0,
  V_GOCE_VIDA: 0,
  V_GOCE_IDENTIFICACION_PERSONAL: 0,
  V_STDAPSALUDMENTA: 0,
  V_CURIOCONSPAD: 0,
  V_CURIOCONSPAAT: 0,
  V_ESTAPELIGROMUERT: 0,
  V_AMENAZAINT: 0,
  FUNCIONARIO_ID: null,
  FILES: [],
  FACTORES_RIESGO: [],
  PUNTO_REFERENCIA: null,
  ENTIDAD_FUNCIONARIO: null,
  NOMBRE_FUNCIONARIO: null,
};
const afectadoDefault = {
  id: null,
  NOMBRE: null,
  APELLIDO: null,
  TIPO_DOCUMENTO_ID: null,
  DOCUMENTO: null,
  GENERO_ID: null,
  IDENTIDAD_GENERO_ID: null,
  ORIENTACION_ID: null,
  CARACT_RURAL: 0,
  CARACT_URBANO: 0,
  CARACT_CAMPESINO: 0,
  CARACT_INDIGENA: 0,
  CARACT_MESTIZO: 0,
  CARACT_AFRO_COLOMBIANO: 0,
  CARACT_ISLENIO: 0,
  CARACT_RAIZAL: 0,
  CARACT_GITANO: 0,
  CARACT_CON_DISCAPACIDAD: 0,
  CARACT_LGBTI: 0,
  CARACT_MIGRANTE: 0,
  CARACT_CONFLICO_ARMADO: 0,
  CARACT_NO_IDENTIFICA: 0,
  GRADO_ESCOLAR_ID: null,
  NIVEL_ESCOLAR_ID: null,
  ESPERA_BEBE: 2,
  NUMERO_HIJOS_ID: null,
  COMUNA_ID: null,
  BARRIO_ID: null,
  COMUNA_NAME: null,
  BARRIO_NAME: null,
  DIRECCION: null,
  PUNTO_REFERENCIA: null,
  POLITICA: false, // NO SE GUARDA EN BD
  TELEFONO: null,
  FECHA_NACIMIENTO: null,
  PAIS_NACIMIENTO: null,
  RANGO_EDAD_ID: null,
};

export default {
  namespaced: true,
  state: {
    item: JSON.parse(JSON.stringify(itemDefault)),
    afectadoDefault: JSON.parse(JSON.stringify(afectadoDefault)),
    pageValidate: {
      page1: false,
      page2: false,
      page3: false,
      page4: false,
    },
    page: 1,
    tiposDocumentos: [],
    countries: [],
    generos: [],
    orientacionesSexuales: [],
    genderIdentities: [],
    ageRanges: [],
    nivelesEscolares: [],
    gradosEscolares: [],
    comunas: [],
    barrios: [],
    problematics: [],
    riskFactors: [],
    numeroHijos: [],
    lugaresAlerta: [],
    funcionarios: [],
  },
  mutations: {
    setItem(state: any, payload: any) {
      state.item = payload;
    },
    changePage(state: any, newPage: number) {
      state.page = newPage;
      window.scrollTo(0, 0);
    },
    setTiposDocumentos(state: any, payload: Array<{ DESCRIPCION: any; id: any; SIGLA: any }>) {
      state.tiposDocumentos = payload.map((e) => ({
        text: e.DESCRIPCION,
        value: e.id,
        sigla: e.SIGLA,
      }));
    },
    setGeneros(state: any, payload: Array<{ DESCRIPCION: any; id: any }>) {
      state.generos = payload.map((e) => ({ text: e.DESCRIPCION, value: e.id }));
    },
    setGenderIdentities(state: any, payload: Array<{ DESCRIPCION: any; id: any }>) {
      state.genderIdentities = payload.map((e) => ({ text: e.DESCRIPCION, value: e.id }));
    },
    setCountries(state: any, payload: Array<{ DESCRIPCION: string; id: number }>) {
      state.countries = payload.map((e) => ({ text: e.DESCRIPCION, value: e.id }));
    },
    setAgeRanges(
      state: any,
      payload: Array<{
        id: number;
        DESCRIPCION: string;
        EDAD_MAXIMA: number;
        EDAD_MINIMA: number;
      }>,
    ) {
      state.ageRanges = payload.map((e) => ({
        value: e.id,
        text: e.DESCRIPCION,
        maxAge: e.EDAD_MAXIMA,
        minAge: e.EDAD_MINIMA,
      }));
    },
    setOrientacionesSexuales(state: any, payload: Array<{ DESCRIPCION: any; id: any }>) {
      state.orientacionesSexuales = payload.map((e) => ({ text: e.DESCRIPCION, value: e.id }));
    },
    setNivelesEscolares(state: any, payload: Array<{ DESCRIPCION: any; id: any }>) {
      state.nivelesEscolares = payload.map((e) => ({ text: e.DESCRIPCION, value: e.id }));
    },
    setGradosEscolares(
      state: any,
      payload: Array<{ DESCRIPCION: any; id: any; NIVEL_ESCOLAR_ID: number }>,
    ) {
      state.gradosEscolares = payload.map((e) => ({
        text: e.DESCRIPCION,
        value: e.id,
        scholarLevelId: e.NIVEL_ESCOLAR_ID,
      }));
    },
    setNumeroHijos(state: any, payload: Array<{ DESCRIPCION: any; id: any }>) {
      state.numeroHijos = payload.map((e) => ({ text: e.DESCRIPCION, value: e.id }));
    },
    setLugaresAlerta(state: any, payload: Array<{ DESCRIPCION: any; id: any }>) {
      state.lugaresAlerta = payload.map((e) => ({ text: e.DESCRIPCION, value: e.id }));
    },
    setFuncionarios(state: any, payload: Array<{ NOMBRE: any; id: any }>) {
      state.funcionarios = payload.map((e) => ({ text: e.NOMBRE, value: e.id }));
    },
    setProblematics(state: any, payload: Array<{ DESCRIPCION: any; id: any }>) {
      state.problematics = payload.map((e) => ({
        text: e.DESCRIPCION,
        value: e.id,
      }));
    },
    setRiskFactors(state: any, payload: Array<{ DESCRIPCION: any; id: any }>) {
      payload.splice(0, 1);
      state.riskFactors = payload.map((e) => ({
        text: e.DESCRIPCION,
        value: e.id,
      }));
    },
    setComunas(state: any, payload: Array<{ DESCRIPCION: any; id: any }>) {
      state.comunas = payload.map((e) => ({
        text: e.DESCRIPCION,
        value: e.id,
      }));
    },
    setBarrios(state: any, payload: Array<{ DESCRIPCION: any; id: any; COMUNA: any }>) {
      state.barrios = payload.map((e) => ({
        text: e.DESCRIPCION,
        value: e.id,
        COMUNA: e.COMUNA,
      }));
    },
    setPageValidate(state: any, payload: { page: number; state: boolean }) {
      if (payload.page) {
        state.pageValidate[`page${payload.page}`] = payload.state;
      }
    },
  },
  getters: {
    getTextById: (state: any) => (id: any, list: string, field: string) => {
      const e = state[list].find((element: any) => element.value === id);
      if (e) {
        return e[field];
      }
      return undefined;
    },
  },
};
